const carDetailScript = (imageComments) => {
  var slide = $('.car-content-in-list');
  var comment = $('.car-content-in-comment-list li');
  var navigation = $('.car-content-in-thumb-list li');

  slide.slick({
    autoplay: true,
    arrows: false,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1
  });
  navigation.each(function(index){ //サムネイルに連番付与属性
    $(this).attr('data-number', index);
  });
  navigation.eq(0).addClass('current');  //1枚をオーバーレイ

  navigation.on('click', function(){ //サムネイルクリック時イベント
    var number = $(this).attr('data-number');
    slide.slick('slickGoTo', number, true);
    $(this).siblings().removeClass('current');
    $(this).addClass('current');
  });

  $('.car-content-in-main dl dd').hide();
  $('.car-content-in-main dl dt').click(function(){
      $(this).next('.car-content-in-main dl dd').slideToggle();
      $(this).toggleClass('open');
  });

  comment.text(imageComments[0] || '');
  slide.on('afterChange', function(_, __, currentSlide) {
    comment.text(imageComments[currentSlide] || '');
  });
};

export default {
  carDetailScript,
};